import GlobalClientDashboardContainer from '../Global/GlobalClientDashboardContainer'
import React from 'react'
import { CssBaseline } from '@mui/material'
import {
  initFbPixels,
  trackFbPixelsPageView,
} from '../../lib/analytics/fbPixels'

interface ISchoolUserParentContainerComponent {
  children?: any // for react children
  school_id: string
  fb_pixel_id?: string
}

const SchoolUserParentContainerComponent: React.FunctionComponent<ISchoolUserParentContainerComponent> = (
  props: ISchoolUserParentContainerComponent,
) => {
  React.useEffect(() => {
    if (props.fb_pixel_id) {
      initFbPixels(props.school_id, props.fb_pixel_id)
      trackFbPixelsPageView(props.school_id, props.fb_pixel_id)
    }
  }, [])

  return (
    <GlobalClientDashboardContainer>
      <div>
        <CssBaseline />
        <main>{props.children}</main>
      </div>
    </GlobalClientDashboardContainer>
  )
}

export default SchoolUserParentContainerComponent
